import React, { Component } from 'react';
import { connect } from 'react-redux';
import { values, flatten } from 'lodash';
import { MATERIAL_ETC_TAG_NAME, TAG_GROUP_KIND } from '../../../../constants/service/app/tagConstants';
import PreviewProductDetailModal from '../../../../views/app/common/modal/PreviewProductDetailModal';
import mainEmptyImg from '../../../../static/images/product/prodDetailPreview/mainEmptyImg.png';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { checkIsBetween } from '../../../../lib/common';

class ModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imgPage: 0,
      isShowExtra: false,
      isShowDeliveryInfoLayer: false,
    };
  }

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'productDetailPreviewModal', value: false });
  };

  /**
   * 다음 버튼
   */
  next = () => {
    const { mainImg, subImg } = this.props.data;
    if (this.state.imgPage < mainImg.length + subImg.length) {
      this.setState({
        imgPage: this.state.imgPage + 1,
      });
    }
  };

  /**
   * 이전 버튼
   */
  prev = () => {
    if (this.state.imgPage > 0) {
      this.setState({
        imgPage: this.state.imgPage - 1,
      });
    }
  };

  /**
   * 상세 더보기
   */
  extraToggle = () => {
    this.setState({
      isShowExtra: !this.state.isShowExtra,
    });
  };

  /**
   * 바로배송 안내 레이어 토글
   */
  deliveryInfoLayerToggle = () => {
    this.setState({
      isShowDeliveryInfoLayer: !this.state.isShowDeliveryInfoLayer,
    });
  };

  /**
   * 상품 상세 미리보기를 위한 데이터 가공
   */
  setProdDetailData = (data) => {
    let productImgList = [];
    const {
      mainImg = [],
      subImg = [],
      tagLinkData,
      discountStartDate,
      discountEndDate,
      optionList,
      isTodayDelivery,
    } = data;
    /**
     *  대표이미지 적용
     */
    mainImg.length ? productImgList.push(mainImg[0]) : productImgList.push({ url: mainEmptyImg });
    /**
     *  추가이미지 적용
     */
    productImgList = productImgList.concat(subImg);
    /**
     *  소제/베이스 태그 그룹에서 "기타소재" 태그 선택여부
     */
    const isSelectMaterialEtcTag = !!(
      tagLinkData[TAG_GROUP_KIND.MATERIAL_BASE] &&
      tagLinkData[TAG_GROUP_KIND.MATERIAL_BASE].find((name) => name === MATERIAL_ETC_TAG_NAME)
    );
    /**
     *  해당 상품에 연결된 모든 태그 리스트
     */
    const relatedTagList = flatten(values(tagLinkData));

    /**
     *  일반 배송정보(그외옵션)을 보여줄지 결정하는 값
     *  optionList = 체크 AND 노출, 품절 상태인 옵션으로 구성
     */
    let showGeneralDeliveryInfo = false;
    /**
     *  옵션리스트에서 오늘출발이 아닌 옵션이 1건 이상있는 경우
     *  일반 배송정보(그외옵션) 노출
     */
    if (optionList && optionList.length) {
      showGeneralDeliveryInfo = !!optionList.find((item) => !item.isTodayDelivery);
    } else {
      /**
       *  오늘 출발 상품이 아닌 경우
       *  일반 배송정보 노출
       */
      showGeneralDeliveryInfo = !isTodayDelivery;
    }

    return {
      ...data,
      productImgList,
      isSelectMaterialEtcTag,
      relatedTagList,
      showGeneralDeliveryInfo,
      /**
       *  할인 가능 여부
       */
      discountAvailable:
        (discountStartDate &&
          discountEndDate &&
          checkIsBetween(DATE_FORMAT.FULL_DASH_FORMAT, discountStartDate, discountEndDate)) ||
        (!discountStartDate && !discountEndDate),
    };
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <PreviewProductDetailModal
        {...this.state}
        isOpen={isOpen}
        data={this.setProdDetailData(data)}
        prev={this.prev}
        next={this.next}
        extraToggle={this.extraToggle}
        deliveryInfoLayerToggle={this.deliveryInfoLayerToggle}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.productDetailPreviewModal.isOpen,
    data: state.app.productDetailPreviewModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ModalContainer));
